import { render, staticRenderFns } from "./_promotionsTable.vue?vue&type=template&id=0beba6e4"
import script from "./_promotionsTable.vue?vue&type=script&lang=js"
export * from "./_promotionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports